module.exports = __webpack_public_path__ + "img/CHOCOSWAMP.a61d43db.svg";